import { SETTING } from '../actionTypes';
import { pushNotification } from "../../apis/nontransactional";
import { _getPushNotificationTopics } from '../../controllers';
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
import { _pushNotificationTopicSubUnsub, _reSubUnSubPushNotificationTopic } from '../../controllers/settings';
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End

export const getPushNotification = () => async (dispatch) => {
    try {

        let resp = await pushNotification();

        dispatch(Setting(resp));
    } catch (error) {
        dispatch(getSettingFailure([]));
    }

};

export const getPushNotificationTopics = () => async (dispatch) => {
    try {
        const objResp = await _getPushNotificationTopics();

        dispatch(getPushNotificationTopicsSuccess(objResp?.data));
    } catch (error) {
        dispatch(getPushNotificationTopicsFailure([]));
    }

};


export const Setting = (notify) => {
    return { type: SETTING.GET_SETTING, payload: notify };
};


export const getSettingFailure = (setting) => {
    return { type: SETTING.GET_SETTING_FAILURE, payload: setting };
};

export const getPushNotificationTopicsSuccess = (setting) => {
    return { type: SETTING.GET_PUSH_NOTIFICATION_TOPIC_SUCCESS, payload: setting };
};

export const getPushNotificationTopicsFailure = (setting) => {
    return { type: SETTING.GET_PUSH_NOTIFICATION_TOPIC_FAILURE, payload: setting };
};

//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
export const pushNotificationTopicSubUnsub = (topicList) => async (dispatch, getState) => {
    let notificationPayload = topicList;
    const arrPushNotificationTopics = getState()?.setting?.arrPushNotificationTopics;
    if (!topicList?.length) {
        if (arrPushNotificationTopics?.length) { notificationPayload = arrPushNotificationTopics; }
        else {
            const objResp = await _getPushNotificationTopics();
            dispatch(getPushNotificationTopicsSuccess(objResp?.data));
            notificationPayload = objResp?.data;
        }
    }

    const userId = getState()?.auth?.userId;
    try {
        const objResp = await _pushNotificationTopicSubUnsub(notificationPayload, userId);

        dispatch(pushNotificationTopicSubUnsubSuccess(objResp?.data));

    } catch (error) {
        dispatch(pushNotificationTopicSubUnsubFailure([]));
    }

};

export const pushNotificationTopicSubUnsubSuccess = (payload) => {
    return { type: SETTING.PUSH_NOTIFICATION_TOPIC_SUB_UNSUB_SUCCESS, payload: payload };
};

export const pushNotificationTopicSubUnsubFailure = (payload) => {
    return { type: SETTING.PUSH_NOTIFICATION_TOPIC_SUB_UNSUB_FAILURE, payload: payload };
};
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End

//Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - Start
export const reSubUnSubPushNotificationTopic = (payload) => async (dispatch) => {
    try {
        const objResp = await _reSubUnSubPushNotificationTopic(payload);

        dispatch(pushNotificationTopicSubUnsubSuccess(objResp?.data));

    } catch (error) {
        dispatch(pushNotificationTopicSubUnsubFailure([]));
    }
};
//Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - End

